import { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { geteApplyCookieValue } from "../shared/SharedUtility";
import { funcSaveUserDetails } from "../store/actions/UserAction";
import { funcRetrieveApplication } from "../store/actions/RetrieveActions";
import { funcTrackApplication } from "../store/actions/TrackActions";
import { funcSaveVkycStatus } from "../store/actions/CardListActions";
import {
    fetchAppContent,
    funcGetSelectedCardData,
    funcUpdateCurrentAppState,
    funcHandleGenericError,
    funcSetBootAppFlag,
    setAppBootLoader
} from "../store/actions/AppStateActions";
import Cookies from "js-cookie";
import { GetAPIErrorMsgForErrorCode, trackPages, getMetaCardName, getNetworkDetails, getCardType} from "../shared/utility";
import { TrackRetNavigate } from "../shared/TrackRetUtility";
import { funcFetchMasterData, funcFetchCityData, funcFetchBankListData, getProductData } from "../store/actions/MasterDataActions";
import Dbfunctions from "../PouchDb/Pouchdb";
import { useErrorCodeVerbiage } from "../shared/AppContent";
import AuditLogging from '../services/AuditLogging.Service';
import { appNavigateTo } from "../store/actions/navActions";


const useCard = () => {
    const { errorCodeContent } = useErrorCodeVerbiage();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isCardName, setIsCardName] = useState(false);
    const [hypervergeStatusCode, setHyperVergeStatusCode] = useState('')
    const [hypervergeDecision, setHyperVergeDecision] = useState('')
    const [noCard, setNoCard] = useState(false);
    const [cardName, setCardName] = useState("");
    const [noCardName, setNoCardName] = useState(false);
    const [isTrackRet, setIsTrackRet] = useState(false);
    const [hsTokenCardChg, setHsTokenCardChg] = useState(false);
    const currentAppState = useSelector((state) => state.AppState);
    const finarkeinStatus = useSelector((state) => state.IncomeSurrogate.finarkeinStatus);
    const perfiosRedirectedStrState = useSelector((state) => state.IncomeSurrogate.perfiosRedirectSts);
    let hypervergeStatus = ["APPROVED", "DECLINED", "INCOMPLETE", "NOSLOTS", "LOCATIONNONCOMPLIANT"];
    const nwData = useSelector(state => state.CardDetails?.nwList);
    const userDetail = useSelector((state) => state.User.UserDetail);
    const fetchAppData = () =>
        dispatch(fetchAppContent());
    const getAllProductData = () => {
        dispatch(getProductData())
    };
    const retrieveApp = (val, gemId1, gemId2) => dispatch(funcRetrieveApplication(val, gemId1, gemId2));
    const saveUserDetail = (userDetail) =>
        dispatch(
            funcSaveUserDetails(userDetail, "personalDetails", "SavePerDetails")
        );
    const trackApp = (hsToken, partnerFlag, debitFlag, status,finarkeinStatus,perfiosRedirectSts) => {

        dispatch(funcTrackApplication(hsToken, partnerFlag, debitFlag, status,finarkeinStatus,perfiosRedirectSts))
    };
    const saveVkycStatus = (status) => {
        dispatch(funcSaveVkycStatus(status));
    };
    const fetchSelectedCardData = (cardListContent, cardName, cardKey) =>
        dispatch(funcGetSelectedCardData(cardListContent, cardName, cardKey));
    const updateState = useCallback(
        (currentAction, screenName) =>
            dispatch(funcUpdateCurrentAppState(currentAction, screenName)),
        [dispatch]
    );

    const [isMasterDataGetAPICalled, setIsMasterDataGetAPICalled] = useState(false);
    const funcGetCityData = useCallback((cardTypeData) => { dispatch(funcFetchCityData(cardTypeData)); }, [dispatch]);
    const funcGetMasterData = useCallback((cardTypeData) => dispatch(funcFetchMasterData(cardTypeData)), [dispatch]);
    const fetchBankList = useCallback((cardType) => dispatch(funcFetchBankListData(cardType)), [dispatch]);
    const funcHandleError = (isGenericError, handleClick, exitEvent, errorMessage) => dispatch(funcHandleGenericError(isGenericError, handleClick, exitEvent, errorMessage))
    const setLoader = (value) => dispatch(setAppBootLoader(value));
    const eApplyCookie = geteApplyCookieValue();
    
    var userRevisitId = "USER_REVISIT";
    const checkVisit = async (hyperVergeRedirect) => {
        const res = await Dbfunctions.GetState(userRevisitId);
        // eslint-disable-next-line no-unused-vars
        var revisitLoc;
        if (res._rev) {
            if(!hyperVergeRedirect && hyperVergeRedirect !== "NOSLOTS" && hyperVergeRedirect !== "LOCATIONNONCOMPLIANT")
            TrackRetNavigate(userDetail, dispatch, updateState, true);
        } else {
            storeDataToPouchDb();
        }

    };

    const storeDataToPouchDb = async () => {
        // eslint-disable-next-line no-unused-vars
        var resDel = await Dbfunctions.CreateState({ _id: userRevisitId, createdDate: new Date().getTime() });
    }


    useEffect(() => {
        let cardType = getCardType(currentAppState?.cardListDetails?.cardType, userDetail?.cardType);
        if (cardType && !isMasterDataGetAPICalled) {
            const cardTypeData = {
                cardType: cardType,
                cardChannelCode: userDetail.channelCode,
            };
            funcGetMasterData(cardTypeData);
            fetchBankList(cardTypeData);
            funcGetCityData(cardTypeData);
            setIsMasterDataGetAPICalled(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentAppState]);

    const bootAppAgain = () => {
        funcSetBootAppFlag(dispatch, false);
        setLoader(true);
        Promise.all([fetchAppData()]).then((resp) => {
            setLoader(false);
            if (resp[0] === "000") { // check if got content successfuly then close popup
                funcHandleError(false, null, null, '');
            }
        })
    }

    useEffect(() => {
        if (currentAppState?.applicationBootFailed) {
            funcHandleError(true, () => bootAppAgain(), () => navigate("/maintainance"), GetAPIErrorMsgForErrorCode("bootAppErrors", "999", errorCodeContent));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentAppState?.applicationBootFailed]);

    useEffect(() => {
        localStorage.removeItem("shortCode");
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        const currentPath = window.location.pathname.split("/");
        fetchAppData();
        const referCode = searchParams.get("referralcode");
        const track = searchParams.get("track");
        const retrive = searchParams.get("retrieve");
        if (!currentPath[2] && !queryString) {
            if (eApplyCookie && eApplyCookie?.hsToken && !retrive && !track) {
                setNoCardName(true);
                retrieveApp(eApplyCookie?.hsToken);
            }
            else {
                setNoCardName(true);
            }
        }
        else {
            if (currentPath[2] === "c" || currentPath[2] === "C") {
                saveUserDetail({ ...userDetail, campaign: true });
                // setCardName(currentPath[3]);
                const metaCardName =  getMetaCardName(currentPath[3]);
                setCardName(metaCardName);
            }
            else {
                const metaCardName =  getMetaCardName(currentPath[2]);
                if (eApplyCookie && eApplyCookie?.hsToken && !retrive && !track) {
                    // setCardName(currentPath[2]);
                    setCardName(metaCardName);
                    retrieveApp(eApplyCookie?.hsToken);
                }
                else {
                    //setCardName(currentPath[2]);
                    setCardName(metaCardName);
                }
            }
            let cShortCode = "";
            let gemId1 = "";
            let gemId2 = "";
            let chnCode = "";
            if (searchParams.get("GEMID1")) {
                gemId1 = searchParams.get("GEMID1");
            } else {
                gemId1 = searchParams.get("gemid1");
            }
            if (searchParams.get("GEMID2")) {
                gemId2 = searchParams.get("GEMID2");
            } else {
                gemId2 = searchParams.get("gemid2");
            }
            if (Cookies.get("lg_partner_lead")){
                saveUserDetail({ ...userDetail, channelCode: Cookies.get("lg_partner_lead"), coreCardChannel:Cookies.get("lg_partner_lead")});
                Cookies.remove('lg_partner_lead');
            } 
            if (searchParams.get("CHN")) {
                chnCode = searchParams.get("CHN");
            } else {
                chnCode = searchParams.get("chn");
            }
            const obcCode = searchParams.get('obc');
            const gemidSource = searchParams.get('source');
            const debitRedirect = searchParams.get('debit');
            const partnerRedirect = searchParams.get('partner');
            let hyperVergeRedirect = "";
            const finarkeinRedirect = searchParams.get('consentStatus')?.toUpperCase();
            let perfiosRedirectSts ="";
            if(searchParams.get('transactionId') && searchParams.get('status'))
                perfiosRedirectSts = searchParams.get('status')?.toUpperCase();
            else if(searchParams.get('status')?.toUpperCase())
                hyperVergeRedirect = searchParams.get('status')?.toUpperCase();
            if (searchParams.get("CS")) {
                cShortCode = searchParams.get("CS");
            } else if (searchParams.get("cs")) {
                cShortCode = searchParams.get("cs");
            } else {
                if (!debitRedirect) {
                    localStorage.removeItem("gemId1");
                    localStorage.removeItem("gemId2");
                    localStorage.setItem("chnCode", chnCode);
                    if (gemId1)
                        localStorage.setItem("gemId1", gemId1);
                    if (gemId2)
                        localStorage.setItem("gemId2", gemId2);
                    const lg_lite_partner_chanel = window.global.config?.LG_LITE_PARTNER_CHANEL;
                    if (userDetail?.channelCode && lg_lite_partner_chanel.includes(userDetail.channelCode))
                        localStorage.setItem("sourceCode", "DC");
                    else
                        localStorage.setItem("sourceCode", "WEBS");
                    localStorage.setItem("cShortCode", cShortCode);
                    if (!obcCode || !retrive || !track) {
                        localStorage.setItem("obcCode", cShortCode);
                    }
                    var Cs_Date_Time = new Date().toLocaleString();
                    localStorage.setItem("lastCsDatetime", Cs_Date_Time);
                }
            }
            
            if (Cookies.get("stp-change-card")) {
                handleChangeCardJour();
            } else if (referCode) {
                handleReferralCode(referCode, currentPath[2]);
            } else if (track) {
                handleTrack(track, "", obcCode);
            } else if (retrive) {
                handleRetrive(retrive, gemId1, gemId2, obcCode);
            } else if (currentPath[2] === "c" || currentPath[2] === "C") {
                handleShortCodeGemId(cShortCode, gemId1, gemId2, chnCode);
            } else if (currentPath[2] !== "c" && currentPath[2] !== "C" && (gemId1 || gemId2)) {
                handleGemIdRedirection(gemId1, gemId2, chnCode, currentPath[2], gemidSource, cShortCode);
            } else if (cShortCode) {
                localStorage.setItem("sourceCode", "DC");  // else chnCode,gemid1 and gemid2 get blank on refresh without browser close
            } else if (debitRedirect) {
                handleDebitRedirection();
            } else if (partnerRedirect) {
                let CookieData = Cookies.get('partner-Data');
                localStorage.setItem("partnerRedirect", partnerRedirect);
                const partnerFlag = true;
                if (CookieData) {
                    let partnerData = CookieData.split('|');
                    let hstoken = partnerData[0];
                    handleTrack(hstoken, partnerFlag);
                }
            }
            else if (hyperVergeRedirect !== "") {  
                let status = "";
                let statusCodeArray = ["HYV50005","HYV50010","HYV50015","HYV50020","HYV50025"];
                switch (hyperVergeRedirect) {
                    case "APPROVED":
                        status = statusCodeArray[0];
                        break;
                    case "DECLINED":
                        status = statusCodeArray[1];
                        break;
                    case "INCOMPLETE":
                        status = statusCodeArray[2];
                        break;
                    default:
                        (hyperVergeRedirect.toUpperCase() === "NOSLOTS") ? status = statusCodeArray[4]:status = statusCodeArray[3];
                        saveVkycStatus(hyperVergeRedirect);
                }
                const decisionCodeObj = {
                    "APPROVED": "vkyc_000",
                    "DECLINED": "vkyc_001",
                    "INCOMPLETE": "vkyc_002",
                    "LOCATIONNONCOMPLIANT": "vkyc_003",
                    "NOSLOTS": "vkyc_004",
                } 
                
                let hsToken = localStorage.getItem('hsToken');
                if (hypervergeStatus.includes(hyperVergeRedirect)) {
                    setHyperVergeStatusCode(decisionCodeObj[hyperVergeRedirect])
                    setHyperVergeDecision(hyperVergeRedirect)
                    handleTrack(hsToken,"","","",status);
                }
            }
            else if((finarkeinRedirect!=="" && finarkeinRedirect!==undefined && finarkeinRedirect!=="undefined" && finarkeinRedirect!=="null") || (perfiosRedirectSts!==undefined && perfiosRedirectSts!=="" && perfiosRedirectSts!=="undefined" && perfiosRedirectSts!=="null")){
                let hsToken = localStorage.getItem('hsToken');
                finarkeinRedirect ? handleTrack(hsToken,"","","","",finarkeinRedirect,"") :  handleTrack(hsToken,"","","","","",perfiosRedirectSts);
            }    
            checkVisit(hyperVergeRedirect);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (nwData && userDetail?.cardType && currentAppState.cardList?.length) {
            if (isTrackRet && hsTokenCardChg) {
                fetchSelectedCardData(currentAppState?.cardList, cardName, "uniqueIdentifier");

            } else if ((isTrackRet || currentAppState.isSprintTrackRetrieve) && !hsTokenCardChg) {
                let networkDetails = getNetworkDetails("cardType", userDetail?.cardType, nwData);
                //if(networkDetails.length > 0)
                fetchSelectedCardData(currentAppState.cardList, networkDetails?.productType, "productType");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nwData , userDetail?.cardType, currentAppState?.cardList, currentAppState.isSprintTrackRetrieve]);

    useEffect(() => {
        if (currentAppState?.cardList?.length && !isTrackRet && cardName) {
            fetchSelectedCardData(currentAppState?.cardList, cardName, "uniqueIdentifier");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentAppState?.cardList]);

    useEffect(() => {
        if (userDetail?.state && isTrackRet) {
            if (userDetail?.state === "RT000") {
                setNoCardName(true);
                dispatch(appNavigateTo({ goTo: "EapplyContinue", }, "APP_NAVIGATE_TO"));
                navigate("/");
            } else {
                TrackRetNavigate(userDetail, dispatch, updateState);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userDetail?.state]);
    const isProductValid = (productType) => {
        let validProd = nwData?.filter(productDetails => (productDetails.productType === productType));
        return validProd?.length > 0 ? true : false;
    }
             
    useEffect(() => {
        if ((eApplyCookie && eApplyCookie?.hsToken) || isTrackRet || (currentAppState.cardListDetails && currentAppState.cardListDetails.productType)) {
            if (hypervergeStatus.includes(hypervergeDecision)) {
            trackPages("tracking_145", "success", "", hypervergeStatusCode, "Vkyc_" +hypervergeDecision.toLocaleLowerCase() );
            }
            else if(finarkeinStatus !== "") {
                let finarkeinDecision = "";
                switch(finarkeinStatus) {
                    case "ACTIVE":
                        finarkeinDecision="000";
                        break;
                    case "REJECTED":
                        finarkeinDecision="001";
                        break;
                    case "PENDING":
                        finarkeinDecision="002";
                        break;
                        default:
                            break;
                }
                trackPages("tracking_170", "success", "", "AA_" + finarkeinDecision, finarkeinStatus, "stp_account_aggregator_finarcin");
                AuditLogging.sendLog('355', localStorage.getItem("applicationNumber"), '1', "Redirection to sprint from Finarkein, status "+ finarkeinStatus.toLocaleLowerCase());
            }
            else if(perfiosRedirectedStrState) {
                let perfiosDecision = "";
                switch(perfiosRedirectedStrState) {
                    case "COMPLETED" || "REPORT_GENERATION_DEFERRED" || "USER_INTERVENTION_COMPLETED" :
                        perfiosDecision="success";
                        break;
                    default:
                        perfiosDecision="failure";
                        break;
                }
                trackPages("tracking_170", perfiosDecision, "" , "", "GST_"+perfiosRedirectedStrState,"stp_gst_perfios");//3d redirect
               AuditLogging.sendLog('355', localStorage.getItem("applicationNumber"), '1', "Redirection to sprint from perfios status "+ perfiosRedirectedStrState.toLocaleLowerCase());
            }
            if(!nwData)
            getAllProductData();
        } else if (!currentAppState.cardListDetails) {
            setNoCard(true);
            navigate("/error");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentAppState.cardListDetails, isTrackRet , eApplyCookie?.hsToken]);

    useEffect(() => {
        if (nwData && currentAppState?.cardListDetails?.cardType) {
            let networkDetails = getNetworkDetails("cardType", currentAppState?.cardListDetails?.cardType, nwData);     
            saveUserDetail({ ...userDetail, priority: networkDetails?.priority });
            if (!isProductValid(currentAppState?.cardListDetails?.productType)) {
                setNoCard(true);
                navigate("/error");
            }
            else if(currentAppState?.cardListDetails?.uniqueIdentifier){
                fetchSelectedCardData(currentAppState?.cardList, currentAppState?.cardListDetails?.productType, "productType");
                normalFlow(currentAppState?.cardListDetails?.uniqueIdentifier);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nwData, currentAppState?.cardListDetails?.uniqueIdentifier])

    const handleTrack = (hsToken, partnerFlag, obcCode, debitFlag, status,finarkeinStatus,perfiosRedirectSts) => {
        setIsTrackRet(true);
        trackApp(hsToken, partnerFlag, debitFlag, status,finarkeinStatus,perfiosRedirectSts);
        if(obcCode){
            localStorage.setItem("obcCode", obcCode);
            localStorage.setItem("cShortCode", obcCode);
            localStorage.setItem("sourceCode", "DC");
        }
        localStorage.setItem("hsToken", hsToken);
    };

    const handleRetrive = (value, gemId1, gemId2, obcCode) => {
        setIsTrackRet(true);
        retrieveApp(value, gemId1, gemId2);
        localStorage.setItem("obcCode", obcCode);
        localStorage.setItem("cShortCode", obcCode);
        if (obcCode) {
            localStorage.setItem("sourceCode", "DC");
        }
        //localStorage.setItem("hsToken", value);
    };


    const handleChangeCardJour = () => {
        Cookies.remove('stp-change-card');
        const cookie_gemid = Cookies.get("lgpartner_C2b_gemid");
        if (cookie_gemid && cookie_gemid !== null) {
            localStorage.setItem("gemId1", cookie_gemid);
            localStorage.setItem("gemId2", cookie_gemid);
        }
        Cookies.remove('lgpartner_C2b_gemid');
        var hstoken = Cookies.get("hsToken");
        if (hstoken) {
            handleRetrive(hstoken);
            Cookies.remove("hsToken");
            setHsTokenCardChg(true);
        }
    }

    const handleReferralCode = (referCode, refCardType) => {
        setIsTrackRet(true);
        saveUserDetail({ ...userDetail, referralCode: referCode, cardType: refCardType });
    };

    const handleDebitRedirection = () => {
        const applicationNumber = localStorage.getItem("applicationNumber");
        AuditLogging.sendLog('321', applicationNumber, "1", "useCard: redirection successful from java controller");
        const hsToken = localStorage.getItem("hsToken");
        const debitFlag = true;
        AuditLogging.sendLog('321', applicationNumber, "1", "useCard: before invoking track-auth service");
        handleTrack(hsToken, "", "", debitFlag);
        AuditLogging.sendLog('321', applicationNumber, "1", "useCard: after invoking track-auth service");
    }

    const handleShortCodeGemId = (cShortCode, gemId1, gemId2, chnCode) => {
        localStorage.setItem("sourceCode", "DC");
        //if(cShortCode!="org"){
        if (cShortCode) {
            localStorage.setItem("cShortCode", cShortCode);
        }
        else {
            localStorage.setItem("cShortCode", "org");
        }
        localStorage.setItem("chnCode", chnCode);
        localStorage.setItem("gemId1", gemId1);
        localStorage.setItem("gemId2", gemId2);
        localStorage.setItem("obcCode", localStorage.getItem("cShortCode"));
        var Cs_Date_Time = new Date().toLocaleString();
        localStorage.setItem("lastCsDatetime", Cs_Date_Time);  //need to set last cs date datetime 

        //}
    };

    const handleGemIdRedirection = (gemId1, gemId2, chnCode, cardType, gemidSource, cShortCode) => {
        //channelCode: chnCode -- add this code to saveUserDetail when asked to preserve the affiliates channel code
        if (gemidSource) {
            setIsTrackRet(true);
            saveUserDetail({ ...userDetail, cardType: cardType });
            //saveUserDetail({ ...userDetail, gemid1: gemId1, gemid2: gemId2, cardType: cardType });
        }
        //if(cShortCode!="org"){
        localStorage.setItem("chnCode", chnCode);
        localStorage.setItem("gemId1", gemId1);
        localStorage.setItem("gemId2", gemId2);
        localStorage.setItem("cShortCode", cShortCode);
        localStorage.setItem("obcCode", cShortCode);
        var Cs_Date_Time = new Date().toLocaleString();
        localStorage.setItem("lastCsDatetime", Cs_Date_Time);  //need to set last cs date datetime 
        //}
        // saveUserDetail({ ...userDetail, gemid1: gemId1, gemid2: gemId2, cardType: cardTypeID });
    };

    const normalFlow = (value) => {
        // var oauthCookie = Cookies.get("sprint-access-token");
        // if (oauthCookie.indexOf("oAuth")) {
        //     var hstoken = Cookies.get("hsToken");
        //     var applicationNumber = localStorage.get("applicationNumber");
        //     if (hstoken) {
        //         if (applicationNumber) {
        //             setIsTrackRet(true);
        //             trackApp(hstoken);
        //         }
        //         else {
        //             setIsTrackRet(true);
        //             retrieveApp(hstoken);
        //         }
        //     }
        // }
        // else {
        //     navigate(`/${value}`);
        //     setIsCardName(true);
        // }

        localStorage.setItem("cardTypeLocal", value);
        var cShortCode_val = localStorage.getItem("cShortCode");
        if (localStorage.getItem("sourceCode") === "DC") {
            //if(cShortCode_val=="org"){
            if (cShortCode_val !== "" && cShortCode_val !== "null" && cShortCode_val !== null && cShortCode_val !== "undefined") {
                value = value + "?CS=" + cShortCode_val;
                trackPages("tracking_1");
                trackPages("tracking_2");
                trackPages("tracking_3");

            } else {
                // localStorage.setItem("sourceCode", "WEBS");
            }
            //} 
        }
        navigate(`/${value}`);
        setIsCardName(true);

    };

    return [isCardName, noCard, isTrackRet, noCardName];
};

export default useCard;
